import { BarChart3, CalendarDays, CalendarPlus, CheckSquare, Home, ListChecks, Settings, UserCog, Users, type LucideIcon } from 'lucide-react'
import type { Permission } from '@/domain/vacations'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  permission?: Permission
  /** Shown in the mobile bottom bar. */
  mobile?: boolean
}

export const NAV_PRIMARY: NavItem[] = [
  { to: '/', label: 'Visão geral', icon: Home, mobile: true },
  { to: '/new', label: 'Marcar férias', icon: CalendarPlus, mobile: true },
  { to: '/requests', label: 'Os meus pedidos', icon: ListChecks, mobile: true },
  { to: '/calendar', label: 'Calendário', icon: CalendarDays, mobile: true },
]

export const NAV_TEAM: NavItem[] = [
  { to: '/approvals', label: 'Aprovações', icon: CheckSquare, permission: 'requests.approve' },
  { to: '/team', label: 'Equipa e saldos', icon: Users, permission: 'team.view' },
  { to: '/reports', label: 'Relatórios', icon: BarChart3, permission: 'team.view' },
]

export const NAV_ADMIN: NavItem[] = [
  { to: '/people', label: 'Pessoas', icon: UserCog, permission: 'people.manage' },
  { to: '/settings', label: 'Configurações', icon: Settings, permission: 'settings.manage' },
]
